import searchPlugin from '@backstage/plugin-search/alpha';
import { createFrontendModule } from '@backstage/frontend-plugin-api';

export const searchModule = createFrontendModule({
  pluginId: 'search',
  extensions: [
    searchPlugin.getExtension('page:search').override({
      params: {
        loader: async () => {
          const { CustomSearchPage } = await import('../components/search/SearchPage');
          return <CustomSearchPage />;
        },
      },
    }),
  ],
});
